import { Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { CustomersSortDialogData } from '../../../interfaces/customers-sort-dialog-data';

@Component({
  selector: 'cus-customers-sort-dialog-component',
  imports: [
    CommonModule, MatDialogModule, MatButtonModule,
    ReactiveFormsModule,
    MatRadioModule,
  ],
  templateUrl: './customers-sort-dialog-component.html',
  styleUrl: './customers-sort-dialog-component.scss',
})
export class CustomersSortDialogComponent {
  sortControl: FormControl<string | null>;
  private dialogData = inject<CustomersSortDialogData>(MAT_DIALOG_DATA);

  constructor(private dialogRef: MatDialogRef<CustomersSortDialogComponent>) {
    this.sortControl = new FormControl<string | null>(this.dialogData.currentSort ?? null);
  }

  onClose() {
    this.dialogRef.close();
  }

  onReset() {
    this.dialogRef.close({ action: 'reset' });
  }

  onApply() {
    this.dialogRef.close({ action: 'apply', value: this.sortControl.value });
  }
}
